"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

exports.__esModule = true;
exports["default"] = void 0;

var _fns = require("@react-pdf/fns");

var _trailingOffset = _interopRequireDefault(require("../run/trailingOffset"));
/**
 * Get attributed string trailing white space offset
 *
 * @param  {Object}  attributed string
 * @return {number} trailing white space offset
 */


var trailingOffset = function trailingOffset(attributedString) {
  var runs = attributedString.runs || [];
  return (0, _trailingOffset["default"])((0, _fns.last)(runs));
};

var _default = trailingOffset;
exports["default"] = _default;